import type { ButtonConfig } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { EditPage, TreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const EditPageBtn = (props: Props) => {
  const tree = useContext(TreeContext)

  const [formId, setFormId] = useState('')
  useEffect(() => autorun(() => {
    setFormId(tree.selectedKeys[0] || '')
  }), [])

  return <EditPage formCode={props.config.FORM_CODE || tree.treeConfig.Nav_Form?.CODE} formData={{ formId }} />
}

export default EditPageBtn